/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterSkuItem } from './ProductRegisterSkuItem';
import {
    ProductRegisterSkuItemFromJSON,
    ProductRegisterSkuItemFromJSONTyped,
    ProductRegisterSkuItemToJSON,
    ProductRegisterSkuItemToJSONTyped,
} from './ProductRegisterSkuItem';

/**
 * 
 * @export
 * @interface ProductRegisterReqVo
 */
export interface ProductRegisterReqVo {
    /**
     * 用户ID（前端传入）
     * @type {number}
     * @memberof ProductRegisterReqVo
     */
    userId: number;
    /**
     * SPU ID，传入表示在已有SPU下添加SKU
     * @type {number}
     * @memberof ProductRegisterReqVo
     */
    spuId?: number;
    /**
     * SPU名称（商品名称）
     * @type {string}
     * @memberof ProductRegisterReqVo
     */
    productName?: string;
    /**
     * 产地标签：Y-原产地，N-非原产地
     * @type {string}
     * @memberof ProductRegisterReqVo
     */
    originLabel?: string;
    /**
     * 是否年满14岁：Y-年满，N-未满；新建SPU时未传或null默认N
     * @type {string}
     * @memberof ProductRegisterReqVo
     */
    underFourteenYearsOld?: string;
    /**
     * 有效期标识：Y-有保质期，N-无保质期
     * @type {string}
     * @memberof ProductRegisterReqVo
     */
    validPeriod?: string;
    /**
     * 
     * @type {Array<ProductRegisterSkuItem>}
     * @memberof ProductRegisterReqVo
     */
    skus: Array<ProductRegisterSkuItem>;
}

/**
 * Check if a given object implements the ProductRegisterReqVo interface.
 */
export function instanceOfProductRegisterReqVo(value: object): value is ProductRegisterReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('skus' in value) || value['skus'] === undefined) return false;
    return true;
}

export function ProductRegisterReqVoFromJSON(json: any): ProductRegisterReqVo {
    return ProductRegisterReqVoFromJSONTyped(json, false);
}

export function ProductRegisterReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRegisterReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'spuId': json['spuId'] == null ? undefined : json['spuId'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'originLabel': json['originLabel'] == null ? undefined : json['originLabel'],
        'underFourteenYearsOld': json['underFourteenYearsOld'] == null ? undefined : json['underFourteenYearsOld'],
        'validPeriod': json['validPeriod'] == null ? undefined : json['validPeriod'],
        'skus': ((json['skus'] as Array<any>).map(ProductRegisterSkuItemFromJSON)),
    };
}

export function ProductRegisterReqVoToJSON(json: any): ProductRegisterReqVo {
    return ProductRegisterReqVoToJSONTyped(json, false);
}

export function ProductRegisterReqVoToJSONTyped(value?: ProductRegisterReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'spuId': value['spuId'],
        'productName': value['productName'],
        'originLabel': value['originLabel'],
        'underFourteenYearsOld': value['underFourteenYearsOld'],
        'validPeriod': value['validPeriod'],
        'skus': ((value['skus'] as Array<any>).map(ProductRegisterSkuItemToJSON)),
    };
}

